import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "rounded bg-slate-50 p-2 mb-2"
};
const _hoisted_2 = {
  class: "text-lg mb-2"
};
const _hoisted_3 = {
  class: "rounded bg-slate-50 p-2"
};
const _hoisted_4 = {
  class: "text-lg mb-2"
};
const _hoisted_5 = {
  class: "w-full"
};
const _hoisted_6 = {
  class: "pr-2"
};
const _hoisted_7 = {
  class: "text-sm"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  colspan: "2"
}, [/*#__PURE__*/_createElementVNode("hr")])], -1);
const _hoisted_9 = {
  class: "pr-2"
};
const _hoisted_10 = /*#__PURE__*/_createTextVNode("--");
const _hoisted_11 = {
  class: "text-sm"
};
import { app } from "@/di";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
export default /*#__PURE__*/_defineComponent({
  __name: 'Stadium',
  props: {
    stadium: null
  },
  setup(__props) {
    const props = __props;
    const maxFoundationLevel = ref(app.get(ConfigRepository).get('stadium.foundation.maxLevel'));
    return (_ctx, _cache) => {
      const _component_NRate = _resolveComponent("NRate");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('foundation')), 1), _createVNode(_component_NRate, {
        readonly: "",
        value: __props.stadium.foundationLevel,
        count: maxFoundationLevel.value
      }, null, 8, ["value", "count"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('terraces')), 1), _createElementVNode("table", _hoisted_5, [_createElementVNode("tr", null, [_createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$t('total')), 1), _createElementVNode("td", null, [_createTextVNode(_toDisplayString(__props.stadium.seats) + "/", 1), _createElementVNode("span", _hoisted_7, _toDisplayString(__props.stadium.limit), 1)])]), _hoisted_8, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stadium.terraces, terrace => {
        return _openBlock(), _createElementBlock("tr", {
          key: terrace.id,
          class: _normalizeClass({
            'opacity-30': !terrace.available
          })
        }, [_createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t(terrace.type)), 1), _createElementVNode("td", null, [!terrace.available ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_hoisted_10], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(terrace.seats) + "/", 1), _createElementVNode("span", _hoisted_11, _toDisplayString(terrace.seatsLimit), 1)], 64))])], 2);
      }), 128))])])]);
    };
  }
});